export default __webpack_public_path__ + "static/background-b7800d0c13b84d881bfcfeda3a392c5e.png";